import React from "react";
import { useNavigate } from 'react-router-dom';
import { Container, Grid, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/";
import Paper from "@material-ui/core/Paper";
import clsx from "clsx";
import { Typography } from "@material-ui/core";


export const MainPage = () => {
  
const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '24px',           // space between buttons
    flexWrap: 'wrap',      // responsive stacking
    padding: '40px 0',
    backgroundColor: '#fff',
  },
  button: {
    width: '220px',        // matches screenshot
    height: '160px',       // taller for multi-line text
    fontSize: '1rem',
    fontWeight: 600,
    textAlign: 'center',
    whiteSpace: 'normal',  // allow text wrapping
    lineHeight: 1.3,
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
   
  },
   paragraphText: {
      textAlign: "justify",
      padding: "20px 10px 20px 10px",
      fontSize: "16px",
    },
    spanText: {
      color: "#140a9a",
  },
    Verbiage: {
    backgroundColor: "#1A0D91",
    color: "#ffffff",
    padding: "30px",
    marginTop: "30px",
    borderRadius: "6px",
    maxWidth: "800px",
    marginLeft: "auto",
    marginRight: "auto",
    textAlign: "center",    
    alignItems: "center",
    justifyContent: "center"
    },
}));


  const navigate = useNavigate();
  const classes = useStyles();
   
    return (
        <Container maxWidth={'xl'} disableGutters={true}>
        
        <Grid container spacing={3} justifyContent="center">
        <Grid item>

        <Button variant="contained" color="primary" className={classes.button} onClick={() => navigate('/files')}>
        Access File Share for an Approved Company
            </Button>
          </Grid>
          <Grid item>
        <Button variant="contained" color="primary"className={classes.button} onClick={() => navigate('/accessrequest')}>
        Request Access to an Approved Company
            </Button>
          </Grid>
          <Grid item>
        <Button variant="contained" color="primary"className={classes.button} onClick={() => navigate('/addcompany')}>
        Request a New Company to be Added
            </Button>
          </Grid>
          <Grid item>
        <Button variant="contained" color="primary" className={classes.button} onClick={() => navigate('/addexternaluser')}>
        Add External User for an Approved Company
      </Button>

      </Grid>
      </Grid>
        <div>
          
          <Paper>
                        <p className={classes.paragraphText}>
                          By use of the KFTP application, I verify that I have read,
                          understood, and agree to comply with all Komatsu policies
                          related to IP distribution and management including but
                          limited to the following:
                          <br />
                          <span className={classes.spanText}>
                            Komatsu Company's Worldwide File Transfer Portal, IT
                            Acceptable Use and Monitoring Policy, Information Security
                            Policy and Intellectual Property Policies and Procedures
                          </span>
                          <br />
                          <br />
                          Any violation of these may result in disciplinary action, up
                          to and including termination of employment and other legal
                          action. Company reserves the right to notify the appropriate
                          law enforcement authorities of any unlawful activity and to
                          cooperate in any investigation of such activity. Company does
                          not consider conduct in violation of this policy to be within
                          a user's course and scope of employment, or the direct
                          consequence of the discharge of the Users duties. Accordingly,
                          to the extent permitted by law, Company reserves the right not
                          to defend or pay damages awarded against any Users that result
                          from violation of this policy.
                        </p>
                      </Paper>
                    
        </div>
        <div className={classes.Verbiage}>
        
            <Typography variant="body1" color="inherit"style={{ fontWeight: "bold" }}>
              KFTP IS NOT INTENDED FOR USE AS LONG-TERM FILE STORAGE
            </Typography>
            <Typography variant="body1" style={{ fontWeight: "bold" }}>
              ALL FILES WILL EXPIRE AFTER 14 DAYS
            </Typography>
          </div>
        
        </Container>
    )
}